<template>
  <article class="layout-section -align-side -reverse">
    <figure
      v-scroll:reveal="{ delay: 50 }"
      class="layout-section__figure -reverse"
      style="background-image: url('/images/home-2.jpg')"
    />

    <section class="layout-section__content">
      <h2 v-scroll:reveal class="layout-section__title">
        {{ wp.projects.title }}
      </h2>

      <p v-scroll:reveal="{ delay: 100 }">
        {{ wp.projects.text }}
      </p>

      <RouterLink v-scroll:reveal="{ delay: 150 }" :to="{ name: 'project-index' }" class="button layout-section__cta">
        Explorez nos projets
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeContent',
  inject: ['wp']
}
</script>
